module.exports = __webpack_public_path__ + "img/logo.1dd58ba2.png";